// 判断是否为开发环境
export const isDevelopment = import.meta.env.DEV || process.env.NODE_ENV === 'development';

// 判断是否启用Mock
export const isMockEnabled = !!import.meta.env.VITE_MOCK;

// 判断是否为生产环境
export const isProduction = import.meta.env.PROD || process.env.NODE_ENV === 'production';


export const G_EmptyStr = '-';

export const PluginIDHashMap: any = {
  // 剪映小助手
  '7522412867740565513': '7576197995168022547', // create_draft
  // 剪映小助手数据生成器
  '7475829177439109155': '7576197995168022547', // add_images
  // 视频合成_剪映小助手
  '7457837925833801768': '7576197995168022547', // str_list_to_objs

  
  'e475829177439109155': '7576197995168022547', // add_masks
  'e576197995168022247': '7576197995168022547', // add_videos
  'e576197995168022348': '7576197995168022547', // easy_create_material
  'e522412867740565313': '7576197995168022547', // get_image_animations
  'e475829177439109455': '7576197995168022547', // audio_timelines
  'e576197995168022647': '7576197995168022547', // video_infos
  'e576197995168022748': '7576197995168022547', // str_to_list
};
